<template>
  <div class="card p-2 d-flex flex-column" :class="{'selected': isSelected}" @click="click" @mouseenter="mouseenter" @mouseleave="mouseleave">
    <div class="top__section mb-1 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="card__icon text-lightmode mr-1" :class="item.icon"></i>
        <span class="card__name text-lightmode">{{$t(item.name)}}</span>
      </div>
      <svg v-if="isSelected" class="radio__btn" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="8.125" stroke="#3C67FF" stroke-width="1.25"/>
        <circle cx="10" cy="9.99978" r="4.86111" fill="#3C67FF"/>
      </svg>
    </div>
    <div class="bottom__section">
      <div class="card__description text-dark6">{{$t(item.description)}}</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  export default {
    name: "ItemCard",
    props: {
      item: Object,
    },
    computed: {
      ...mapState("newonboarding", {
        selected: state => state.welcome.data.pageObjective,
      }),
      isSelected() {
        return this.selected === this.item.value
      }
    },
    methods: {
      click() {
        this.$emit("onSelect", this.item.value);
      },
      mouseenter() {
        this.$emit("onHover", this.item.value);
      },
      mouseleave() {
        this.$emit("onHover", "");
      }
    },
  }
</script>

<style lang="scss" scoped>
  .card {
    width: 204px;
    height: 100px;
    background-color: $light2;
    border: solid 1px $light2;
    border-radius: 3px;

    &__icon {
      font-size: 24px;
    }

    &:hover {
      border: solid 1px $mono3;
      cursor: pointer;
      .card__description {
        visibility: visible;
      }
    }

    &__name {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
    }
    
    &__description {
      font-size: 12px;
      line-height: 18px;
      font-weight: 400;
      visibility: hidden;
    }
  }

  .selected {
    border: solid 1px $mono3 !important;
  }
</style>
